import React from "react";

export function HRStatCard({ label, value, icon: Icon, color = "blue", sub }) {
  const colorMap = {
    blue: { bg: "bg-blue-50", text: "text-blue-600" },
    green: { bg: "bg-green-50", text: "text-green-600" },
    emerald: { bg: "bg-emerald-50", text: "text-emerald-600" },
    amber: { bg: "bg-amber-50", text: "text-amber-600" },
    red: { bg: "bg-red-50", text: "text-red-600" },
    purple: { bg: "bg-purple-50", text: "text-purple-600" },
    slate: { bg: "bg-slate-50", text: "text-slate-600" },
  };
  const c = colorMap[color] || colorMap.blue;

  return (
    <div className={`rounded-xl p-5 ${c.bg} flex flex-col items-center justify-center text-center transition-all duration-300 hover:scale-[1.02] border border-black/5`}>
      {Icon && (
        <div className={`mb-2 ${c.text}`}>
          <Icon className="w-5 h-5" />
        </div>
      )}
      <div className={`text-2xl font-bold font-serif ${c.text} mb-1`}>{value}</div>
      <div className="text-sm font-medium text-slate-500">{label}</div>
      {sub && <p className="text-[11px] text-slate-400 mt-0.5">{sub}</p>}
    </div>
  );
}
